/**
 * Stop iOS zooming the page into a text box.
 *
 * Safari on an iPhone zooms in on focus of any field set smaller than 16px,
 * and leaves the page zoomed after -- which is what made screen after screen
 * look cropped on the right once somebody had tapped a search box. The first
 * answer was to hold every field on a phone at 16px. It worked, and it made
 * every filter, search box and reply box the largest text on a screen of 12-
 * and 14px writing: the desk's word for it was "too big and squished".
 *
 * `maximum-scale=1` is the other answer, and the better one here. Since iOS 10
 * Safari ignores it for the person's own pinch -- reading a wide email's fine
 * print still works -- and honours it only for the zoom it would have done by
 * itself on focus. Fields can then be the size the rest of the screen is.
 *
 * iOS only, and that is the point of doing it here rather than in the page's
 * meta tag: Android never zooms on focus, but Chrome there does honour
 * `maximum-scale` against the person's own pinch, and taking that away from
 * every Android phone to fix an iPhone's habit would be a worse bug than the
 * one it fixes. iPadOS reports itself as a Mac, so a Mac with a touchscreen is
 * taken to be an iPad -- Macs have none.
 */
export function stopIosFocusZoom(): void {
  const ios =
    /iPhone|iPad|iPod/.test(navigator.userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  if (!ios) return;

  const meta = document.querySelector<HTMLMetaElement>('meta[name="viewport"]');
  if (!meta || meta.content.includes("maximum-scale")) return;
  meta.content = `${meta.content}, maximum-scale=1`;
}
